import {
  Badge,
  Box,
  Button,
  FileButton,
  Flex,
  Grid,
  Loader,
  LoadingOverlay,
  rem,
  TextInput,
  Title,
  Text,
  ActionIcon,
  Tooltip,
} from "@mantine/core";
import { useDebouncedState, useDisclosure } from "@mantine/hooks";
import {
  IconEyeSearch,
  IconFileDownload,
  IconFileExport,
  IconFileTypeCsv,
  IconSearch,
} from "@tabler/icons-react";
import {
  MantineReactTable,
  MRT_ColumnDef,
  MRT_RowSelectionState,
  useMantineReactTable,
} from "mantine-react-table";
import React, { useDeferredValue, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { repositoryMdm } from "../../../_base/_const/_constVar";
import _breadcrumb from "../../../_base/component/_layout/_breadcrumb";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import { BASE_API_MDM } from "../../../config";
import { _localization } from "../../../config/location";
import { MessageResponse } from "../../../model/MessageResponse";
import { formatDateTransfer } from "../../../common/FormatDate/FormatDate";
import { getValueById } from "../../../_base/helper/FunctionHelper";
import { getTblDmEmployeeAll } from "../../../service/getSelectApi";

type ColumnPinningType = {
  left?: string[];
  right?: string[];
};

const ItemFluctuation = ({
  isHome,
  heightProps,
}: {
  isHome: boolean;
  heightProps?: any;
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [data, setData] = useState<any[]>([]);
  const [dataInfo, setDataInfo] = useState<any>({});
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const [height, setHeight] = useState(0);
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 20,
  });
  const rowSelectionDeferred =
    useDeferredValue<MRT_RowSelectionState>(rowSelection);
  const [selectIds, setSelectIds] = useState<string[]>([]);
  const [visible, { toggle, open, close }] = useDisclosure(false);

  const _searchJson = sessionStorage.getItem(String(location.pathname))
    ? JSON.parse(sessionStorage.getItem(String(location.pathname)) ?? "")
    : null;
  const checkedPinSearch = localStorage.getItem("checkedPinSearch") == "true";
  const [search, setSearch] = useState<any>({});
  const [keySearch, setKeySearch] = useDebouncedState<string>(
    _searchJson && checkedPinSearch ? _searchJson?.keySearch : "",
    300
  );
  const [file, setFile] = useState<File | null>(null);
  const resetRef = useRef<() => void>(null);

  const [dataEmployee, setDataEmployee] = useState<any[]>([]);

  const columns = React.useMemo<MRT_ColumnDef<any>[]>(
    () => [
      {
        accessorKey: "itemCode",
        header: "Mã sản phẩm",
        size: 160,
        Cell: ({ row }) => (
          <Badge color="green" variant="dot">
            {row.original.itemCode}
          </Badge>
        ),
      },
      { accessorKey: "note", header: "Biến động giá", size: 475 },
      { accessorKey: "itemName", header: "Tên sản phẩm", size: 475 },
      { accessorKey: "unitName", header: "Đơn vị tính" },
      // { accessorKey: "segment3CodeString", header: "Mã loại" },
      // { accessorKey: "segment3Name", header: "Tên loại" },
      { accessorKey: "segment4CodeString", header: "Mã chủng" },
      { accessorKey: "segment4Name", header: "Tên chủng" },
      // { accessorKey: "attribute1", header: "Thuộc tính 1" },
      // { accessorKey: "attribute2", header: "Thuộc tính 2" },
      // { accessorKey: "attribute3", header: "Thuộc tính 3" },
      // { accessorKey: "attribute4", header: "Thuộc tính 4" },
      // { accessorKey: "attribute5", header: "Thuộc tính 5" },
    ],
    [dataEmployee]
  );

  const clearFile = () => {
    setFile(null);
    resetRef.current?.();
  };

  const fetchData = async () => {
    setIsLoading(true);
    setIsRefetching(true);
    setIsError(false);
    try {
      let url = `/api/v1/ItemFluctuation/get-list?Skip=${
        pagination.pageIndex * pagination.pageSize
      }&Take=${pagination.pageSize}`;

      const params = new URLSearchParams();
      Object.entries(search).forEach(([key, value]) => {
        if (Array.isArray(value) && value.length > 0) {
          value.forEach((item) => params.append(key, String(item)));
        } else if (typeof value === "string" && value.length > 0) {
          params.append(key, value);
        }
      });

      if (keySearch.length > 0) {
        url += `&KeySearch=${keySearch}`;
      }

      url += `&${params.toString()}`;

      const res = await repositoryMdm.get<MessageResponse<any>>(url);

      if (res && res.success) {
        const result = res.data;
        setData(result);
        setRowCount(res.totalCount);
      }
    } catch (error) {
      setData([]);
      setIsError(true);
      console.error(error);
      return;
    } finally {
      setIsLoading(false);
      setIsRefetching(false);
      sessionStorage.setItem(
        String(location.pathname),
        JSON.stringify({
          ...search,
          keySearch: keySearch,
        })
      );
    }
  };

  const handleCollectExcel = async () => {
    open();
    try {
      const token = localStorage.getItem("token");
      await fetch(
        `${BASE_API_MDM}/api/v1/ItemFluctuation/get-import-excel-item-fluctuation-template`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token?.replace(/"/g, "")}`,
            "Content-Type": "application/vnd.ms-excel",
          },
        }
      )
        .then((response) => {
          if (response.ok) {
            return response.blob();
          } else {
            throw new Error("Failed to fetch the resource");
          }
        })
        .then((blob) => {
          const url = window.URL.createObjectURL(blob);
          let filename = "mau_bien_dong_thi_truong_vat_tu.xlsx";
          const link = document.createElement("a");
          link.href = url;
          link.download = filename;
          document.body.appendChild(link);
          link.click();
          link.remove();
          window.URL.revokeObjectURL(url);
          NotificationExtension.Success("Lấy file mẫu thành công !");
        })
        .catch((error) => {
          console.error("Error:", error);
          NotificationExtension.Fails("Lấy file mẫu thất bại !");
        });
    } catch (error) {
      console.log("Error downloading template:", error);
      NotificationExtension.Fails("Tải file mẫu thất bại");
    } finally {
      close(); // Đóng loading overlay sau khi tải xong
    }
  };

  const uploadFile = async (e: File) => {
    if (!e) {
      NotificationExtension.Fails("File rỗng hoặc chưa chọn file !");
      return;
    }
    open();
    // await new Promise((resolve) => setTimeout(resolve, 2000));
    const formData = new FormData();
    formData.append("FormFile", e);

    try {
      const resSaveFile = await repositoryMdm.post<MessageResponse<boolean>>(
        "/api/v1/ItemFluctuation/import-excel",
        formData
      );
      if (resSaveFile && resSaveFile.success) {
        clearFile();
        NotificationExtension.Success("Import file thành công !");
        setTimeout(() => {
          fetchData();
        }, 1000);
      } else {
        NotificationExtension.Fails("Import file thất bại !");
        clearFile();
      }
    } catch (error) {
      console.log(error);
    } finally {
      close();
      clearFile();
    }
  };

  const handleExportExcel = async () => {
    open();
    try {
      let url = `/api/v1/ItemFluctuation/export-excel?Skip=${
        pagination.pageIndex * pagination.pageSize
      }&Take=${pagination.pageSize}`;

      const params = new URLSearchParams();
      Object.entries(search).forEach(([key, value]) => {
        if (Array.isArray(value) && value.length > 0) {
          value.forEach((item) => params.append(key, String(item)));
        } else if (typeof value === "string" && value.length > 0) {
          params.append(key, value);
        }
      });

      if (keySearch.length > 0) {
        url += `&KeySearch=${keySearch}`;
      }

      url += `&${params.toString()}`;

      const _url = BASE_API_MDM + url;
      const token = localStorage.getItem("token");

      const response = await fetch(_url, {
        method: "GET",
        headers: {
          "Content-Type": "application/vnd.ms-excel",
          Authorization: `Bearer ${token?.replace(`"`, "").replace(`"`, "")}`,
        },
      });

      if (!response.ok) {
        NotificationExtension.Fails("Export Excel thất bại !");
      } else {
        NotificationExtension.Success("Export Excel thành công !");
        const blob = await response.blob();
        const urlss = window.URL.createObjectURL(blob);
        const _name = new Date().toISOString().slice(0, 10);
        let filename = "bien_dong_thi_truong_vat_tu" + _name + ".xlsx";
        const link = document.createElement("a");
        link.href = urlss;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      }
    } catch (error) {
      console.error("Error:", error);
    } finally {
      close();
    }
  };

  const fetchDataEmp = async () => {
    const res = await getTblDmEmployeeAll();

    if (res) {
      const data = res
        .filter((item) => item.id && item.fullname)
        .map((item) => ({
          label: `${item.code} - ${item.fullname}`,
          value: String(item.id),
        }));
      setDataEmployee(data);
    }
  };

  // Lưu ghim cột - Function để lấy cấu hình từ localStorage
  const getColumnPinningStorage = () => {
    try {
      const columnPinningStorage = localStorage.getItem(
        "itemFluctuationColumnPinning"
      );
      return columnPinningStorage
        ? JSON.parse(columnPinningStorage)
        : {
            left: ["mrt-row-numbers", "itemCode"],
          }; // Giá trị mặc định
    } catch (error) {
      console.error("Error parsing column pinning storage:", error);
      return {
        left: ["mrt-row-numbers", "itemCode"],
      };
    }
  };

  // State cho columnPinning - khởi tạo từ localStorage
  const [columnPinning, setColumnPinning] = useState<ColumnPinningType>(() =>
    getColumnPinningStorage()
  );

  // Effect để lưu columnPinning vào localStorage mỗi khi có thay đổi
  useEffect(() => {
    try {
      localStorage.setItem(
        "itemFluctuationColumnPinning",
        JSON.stringify(columnPinning)
      );
    } catch (error) {
      console.error("Error saving column pinning to localStorage:", error);
    }
  }, [columnPinning]);

  useEffect(() => {
    //   startTransition(() => {
    const valuesList = Object.keys(rowSelectionDeferred);
    setSelectIds(valuesList);
    if (valuesList.length < 1) setSelectIds([]);
    else {
      const valuesList = Object.keys(rowSelectionDeferred);
      setSelectIds(valuesList);
    }
    //  });
  }, [rowSelectionDeferred]);

  useEffect(() => {
    fetchData();
  }, [pagination?.pageIndex, pagination?.pageSize]);

  useEffect(() => {
    fetchDataEmp();
  }, []);

  useEffect(() => {
    if (isHome) {
      setPagination({
        pageIndex: 0,
        pageSize: 10,
      });
    }
  }, [isHome]);

  useEffect(() => {
    if (file) {
      if (
        file &&
        (file.type ===
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
          file.type === "application/vnd.ms-excel")
      )
        uploadFile(file);
      else NotificationExtension.Fails("File không đúng định đạng Excel !");
    }
  }, [file]);

  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      setHeight(window.innerHeight - (145 + headerHeight));
    };

    handleResize(); // Set initial height
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const table = useMantineReactTable({
    columns,
    data,
    enableColumnResizing: isHome ? true : false,
    positionToolbarAlertBanner: "bottom",
    enableRowNumbers: true,
    //add custom action buttons to top-left of top toolbar
    enableTopToolbar: false,
    mantineTopToolbarProps: {
      style: {
        borderBottom: "3px solid rgba(128, 128, 128, 0.5)",
        marginBottom: 5,
      },
    },
    localization: _localization,
    enableRowSelection: false,
    getRowId: (row) => row.id?.toString(),
    initialState: {
      showColumnFilters: false,
      columnPinning: {
        ...columnPinning,
      },
      columnVisibility: { id: true, phone: false, fax: false },
      density: "xs",
    },
    mantineTableContainerProps: {
      style: {
        maxHeight: !isHome ? height : heightProps,
        minHeight: !isHome ? height : heightProps,
      },
    },
    renderBottomToolbarCustomActions: ({ table }) => (
      <>
        {isHome ? (
          <Flex justify={"space-between"} align={"center"} w={"50%"}>
            <Tooltip label="Xem chi tiết">
              <ActionIcon
                variant="gradient"
                gradient={{ from: "#EA242A", to: "#2A3176", deg: 90 }}
                onClick={() => navigate("/config-system/item-fluctuation")}
              >
                <IconEyeSearch size={18} />
              </ActionIcon>
            </Tooltip>
            <Badge
              variant="gradient"
              gradient={{ from: "#EA242A", to: "#2A3176", deg: 90 }}
            >
              Biến động thị trường vật tư
            </Badge>
          </Flex>
        ) : (
          <Box></Box>
        )}
      </>
    ),
    enableStickyHeader: true,
    manualPagination: true,
    onRowSelectionChange: setRowSelection,
    rowCount: rowCount,
    onPaginationChange: setPagination,
    mantineTableBodyCellProps: ({ row }) => ({
      style: {
        fontWeight: "500", //conditional styling
        fontSize: "12.5px",
        padding: "5px 15px",
      },
    }),
    state: {
      isLoading,
      pagination: pagination,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      showSkeletons: isLoading, //loading for the first time with no data
      rowSelection,
      columnPinning,
    },
    onColumnPinningChange: setColumnPinning,
    mantineToolbarAlertBannerProps: isError
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,
    mantinePaginationProps: {
      showRowsPerPage: isHome ? false : true,
      withEdges: true,
      rowsPerPageOptions: ["10", "20", "50", "100"],
    },
    paginationDisplayMode: isHome ? "default" : "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },
    columnFilterDisplayMode: "popover",
    mantineTableBodyRowProps: ({ row }) => ({
      style: { cursor: "pointer" },
    }),
  });

  return (
    <>
      {!isHome ? (
        <div
          ref={headerRef}
          style={{
            width: "100%",
          }}
        >
          <LoadingOverlay
            visible={visible}
            zIndex={1000}
            overlayProps={{ radius: "sm", blur: 5 }}
            loaderProps={{
              children: (
                <Flex direction={"column"} align="center" gap="xs">
                  <Loader type="dots" size={35}></Loader>
                  {/* <Title size={15}> Đang upload tài liệu...</Title> */}
                  <Title size={15}> Đang xử lý....</Title>
                </Flex>
              ),
            }}
          />
          <Flex justify={"space-between"} align={"center"} w={"100%"}>
            <_breadcrumb></_breadcrumb>
            <Flex align={"center"} gap={"md"}>
              <Button
                leftSection={
                  <IconFileDownload
                    style={{ width: rem(14), height: rem(14) }}
                  />
                }
                onClick={() => handleCollectExcel()}
              >
                Lấy file Excel mẫu
              </Button>
              <FileButton onChange={setFile} resetRef={resetRef}>
                {(props) => (
                  <Button
                    leftSection={
                      <IconFileTypeCsv
                        style={{ width: rem(14), height: rem(14) }}
                      />
                    }
                    {...props}
                  >
                    Import Excel
                  </Button>
                )}
              </FileButton>
              <Button
                leftSection={<IconFileExport size={14} />}
                onClick={() => handleExportExcel()}
              >
                Export Excel
              </Button>
            </Flex>
          </Flex>
          <Grid mt={10} w={"100%"}>
            <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
              <TextInput
                placeholder="Nhập từ khóa tìm kiếm"
                defaultValue={keySearch}
                onChange={(e) => setKeySearch(e.currentTarget.value)}
                leftSection={<IconSearch color="#15aabf" />}
              />
            </Grid.Col>
            <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
              <Button
                onClick={() => fetchData()}
                leftSection={<IconSearch size={14} />}
              >
                Tìm kiếm
              </Button>
            </Grid.Col>
          </Grid>
        </div>
      ) : (
        <></>
      )}
      <Box mt={5}>
        <MantineReactTable table={table} />
      </Box>
    </>
  );
};

export default ItemFluctuation;
